import React from 'react'
import { Stack } from '@mui/material'
import { Item } from './Item.js'

export default function PageFooter() {
    const copyright = '\u{00A9}'
    const tm = '\u{00AE}'
    const fullYear = Math.max(new Date().getFullYear(), 2026)

    const linkStyle = {
        color: '#c5a059',
        textDecoration: 'none',
        cursor: 'pointer',
        padding: '2px 4px',
        borderRadius: '4px',
        transition: 'background-color 0.3s ease, color 0.3s ease',
    }

    const linkHover = (e) => {
        e.target.style.backgroundColor = 'rgba(0, 82, 71, 0.15)'
        e.target.style.color = '#4ebbb4'
    }

    const linkLeave = (e) => {
        e.target.style.backgroundColor = 'transparent'
        e.target.style.color = '#c5a059'
    }

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 4, mb: 4 }}
        >
            <Item style={{ textAlign: 'center' }}>
                <a
                    href="/privacy"
                    style={linkStyle}
                    onMouseEnter={linkHover}
                    onMouseLeave={linkLeave}
                >
                    <b>Privacy</b>
                </a>
                {' | '}
                <a
                    href="#"
                    style={linkStyle}
                    onMouseEnter={linkHover}
                    onMouseLeave={linkLeave}
                    onClick={(e) => {
                        e.preventDefault()
                        if (window.UC_UI) window.UC_UI.showSecondLayer()
                    }}
                >
                    <b>Cookie Settings</b>
                </a>
                {' | '}
                <span style={{ whiteSpace: 'nowrap' }}>
                    {copyright} {fullYear}
                    <b> ElectroBraid</b>
                    <sup>{tm}</sup>
                    <b> Fence </b>- All rights reserved.
                </span>
            </Item>
        </Stack>
    )
}
